export const CHECK_AUTH = 'checkAuth'
export const LOGIN = 'login'
export const LOGOUT = 'logout'

export const USER_DATA_FETCH = 'getUserData'
export const USER_DATA_UPDATE = 'userDataUpdate'
export const USER_BANK_CARD_CREATE = 'userBankCardCreate'
export const USER_BANK_CARD_UPDATE = 'userBankCardUpdate'
export const USER_BANK_CARD_DELETE = 'userBankCardDelete'
export const USER_BANK_ACCOUNT_CREATE = 'userBankAccountCreate'
export const USER_BANK_ACCOUNT_UPDATE = 'userBankAccountUpdate'
export const USER_BANK_ACCOUNT_DELETE = 'userBankAccountDelete'

export const COMPANY_UPDATE = 'companyUpdate'
export const GET_COMPANIES = 'getCompanies' // admin only
export const GET_COMPANY = 'getCompany'
export const GET_COMPANY_TYPES = 'getCompanyTypes'

export const BRANCHES_FETCH = 'getBranches'
export const BRANCH_FETCH = 'getBranch'
export const BRANCH_CREATE = 'branchCreate'
export const BRANCH_UPDATE = 'branchUpdate'
export const BRANCH_DELETE = 'branchDelete'
export const BRANCH_EMPLOYEES_FETCH = 'getBranchEmployees'
export const BRANCH_EMPLOYEES_INVITE = 'inviteBranchEmployees'
export const BRANCH_BANK_CARD_CREATE = 'branchBankCardCreate'
export const BRANCH_BANK_CARD_UPDATE = 'branchBankCardUpdate'
export const BRANCH_BANK_CARD_DELETE = 'branchBankCardDelete'
export const BRANCH_BANK_ACCOUNT_CREATE = 'branchBankAccountCreate'
export const BRANCH_BANK_ACCOUNT_UPDATE = 'branchBankAccountUpdate'
export const BRANCH_BANK_ACCOUNT_DELETE = 'branchBankAccountDelete'

export const GET_CURRENT_BRANCH_PAYMENTS = 'getCurrentBranchPayments'

export const REGISTER_COMPANY = 'registerCompany'
export const START_EMPLOYEE_REGISTRATION_BY_COMPANY = 'startEmployeeRegistrationByCompany'
export const COMPLETE_EMPLOYEE_REGISTRATION_BY_COMPANY = 'completeEmployeeRegistrationByCompany'
export const REGISTER_EMPLOYEE_BY_INVITATION = 'registerEmployeeByInvitation'
export const EMPLOYEE_FETCH = 'getEmployeeData'
export const EMPLOYEE_UPDATE = 'updateEmployee'
export const EMPLOYEE_BRANCH_DETACH = 'detachEmployeeFromBranch'
